@if (show) {
  <div class="modal-container">
    @if (!isReloading) {
      <div class="modal-content">
        <button class="close-button" (click)="onClose()">
          <nb-icon icon="close-outline"></nb-icon>
        </button>
        <h3 style="text-align: center; width: 75%; margin: auto;">{{emailStore.getCurrentImageIndex(taskId) | async}}/{{emailStore.getImagesArrayLength(taskId) | async}} : Choisissez votre image préférée ou recréez-en une :</h3>
        <!-- Sinon, affichez l'image -->
        <div >
          <img [src]="imageUrl" alt="Votre image" />
        </div>
        <div class="button-container">
          @if (selectedButton === 0 || selectedButton === 1) {
            <button nbButton appearance="filled" status="basic" [nbSpinner]="isLoading" (click)="selectImage(1)">Image 1</button>
          }
          @if (selectedButton === 0  || selectedButton === 2) {
            <button nbButton appearance="filled" status="basic" [nbSpinner]="isLoading" (click)="selectImage(2)">Image 2</button>
          }
          @if (selectedButton === 0  || selectedButton === 3) {
            <button nbButton appearance="filled" status="basic" [nbSpinner]="isLoading" (click)="selectImage(3)">Image 3</button>
          }
          @if (selectedButton === 0  || selectedButton === 4) {
            <button nbButton appearance="filled" status="basic" [nbSpinner]="isLoading" (click)="selectImage(4)">Image 4</button>
          }
          <!-- Hide the button when image is being generated (isLoading = true) -->
          @if (!isLoading && (selectedButton === 0  || selectedButton === 5)) {
            <button nbButton appearance="filled" status="basic" (click)="reloadImage(5)">Recréer Image</button>
          }
        </div>
        <!-- Show the progress bar when image is being generated -->
      </div>
    }
    @if (LoadingBar) {
      <div class="loading-bar">
        <p>Génération de l'image...</p>
        <nb-progress-bar [value]="progress" size = "giant" status="info" [displayValue]="true"></nb-progress-bar>
      </div>
    }
  </div>
}

